import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'rebass';

const TinyButton = ({ children, ...props }) => (
  <Button
    style={{
      lineHeight: 1,
      minHeight: 20,
      padding: 5,
      fontSize: 9,
    }}
    p={1}
    {...props}
  >
    {children}
  </Button>
);

TinyButton.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TinyButton;
